import { computed } from 'vue'
import { useAccount, useChainId, useFromChain } from './store.mjs'
import { readInjectedSignerAddress, injectSignerDisplayEpoch } from './injectedSigner.mjs'
import { readTronAccountPassive, resolveTronWeb } from './dapp/tronInject.mjs'
import { base58de } from './dapp/tron.mjs'
import { TRON_CHAIN_ID } from './dapp/receiveAddress.mjs'

function isTronWalletContext(fromChain, chainId) {
  const cid = Number(fromChain?.chainId ?? chainId ?? 0)
  if (cid === TRON_CHAIN_ID) return true
  try {
    return typeof location !== 'undefined' && location.search.includes('fromTron')
  } catch {
    return false
  }
}

/**
 * 兑换/跨链卡片与顶栏对齐的「已连接」判断：
 * - 展示：store.account 或注入层 selectedAddress（顶栏可能只有前者，卡片曾只有后者）
 * - 链上交易：仍以 store.account + provider 为准，需 syncInjectedAccountIfNeeded 回填
 */
export function useWalletLink() {
  const [account] = useAccount()
  const [chainId] = useChainId()
  const [fromChain] = useFromChain()

  const linkedAddress = computed(() => {
    void injectSignerDisplayEpoch.value
    const store = String(account.value || '').trim()
    if (store) return store
    if (isTronWalletContext(fromChain.value, chainId.value)) {
      const passive = readTronAccountPassive()
      if (passive?.account) return String(passive.account).trim()
      try {
        const tw = resolveTronWeb()
        const b58 = tw?.defaultAddress?.base58
        if (b58 && String(b58).startsWith('T')) return base58de(String(b58))
      } catch (_e) {
        void _e
      }
    }
    return readInjectedSignerAddress()
  })

  const isWalletLinked = computed(() => linkedAddress.value.length > 0)

  const storeAccountReady = computed(() => String(account.value || '').trim().length > 0)

  return {
    account,
    linkedAddress,
    isWalletLinked,
    storeAccountReady,
  }
}
